import React from 'react';
import { Flex } from '@instructure/ui-flex';
import { Text } from '@instructure/ui-text';
import { ScoreDisplayFormat } from "../../../../util/gradebook/constants.js";
import { MasteryLevelIcon } from "../../icons/MasteryLevelIcon/index.js";
var Label = function Label(_ref) {
  var scoreDisplayFormat = _ref.scoreDisplayFormat,
    score = _ref.score,
    totalScore = _ref.totalScore,
    text = _ref.text;
  if (scoreDisplayFormat === ScoreDisplayFormat.ICON_AND_LABEL) {
    return /*#__PURE__*/React.createElement(Text, {
      size: "legend"
    }, text);
  }
  if (scoreDisplayFormat === ScoreDisplayFormat.ICON_AND_POINTS) {
    return /*#__PURE__*/React.createElement(Text, {
      size: "legend"
    }, score);
  }
  var isPercentFormat = scoreDisplayFormat === ScoreDisplayFormat.PERCENT;
  var isPercentAndRatioFormat = scoreDisplayFormat === ScoreDisplayFormat.PERCENT_AND_RATIO;
  if (isPercentFormat || isPercentAndRatioFormat) {
    var percent = score != null && totalScore != null && totalScore !== 0 ? "".concat(Math.round(score / totalScore * 100), "%") : null;
    return percent != null ? /*#__PURE__*/React.createElement(Flex, {
      gap: "x-small"
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "bold"
    }, percent), isPercentAndRatioFormat && /*#__PURE__*/React.createElement(Text, null, "(".concat(score, "/").concat(totalScore, ")"))) : null;
  }
};
export var ScoreWithLabel = function ScoreWithLabel(_ref2) {
  var masteryLevel = _ref2.masteryLevel,
    score = _ref2.score,
    totalScore = _ref2.totalScore,
    label = _ref2.label,
    _ref2$scoreDisplayFor = _ref2.scoreDisplayFormat,
    scoreDisplayFormat = _ref2$scoreDisplayFor === void 0 ? ScoreDisplayFormat.ICON_ONLY : _ref2$scoreDisplayFor,
    iconColor = _ref2.iconColor;
  var isPercentFormat = [ScoreDisplayFormat.PERCENT, ScoreDisplayFormat.PERCENT_AND_RATIO].includes(scoreDisplayFormat);
  var justifyItems = scoreDisplayFormat === ScoreDisplayFormat.ICON_ONLY ? 'center' : 'start';
  return /*#__PURE__*/React.createElement(Flex, {
    width: "100%",
    height: "100%",
    alignItems: "center",
    gap: "small",
    padding: "none small",
    justifyItems: justifyItems
  }, !isPercentFormat && /*#__PURE__*/React.createElement(MasteryLevelIcon, {
    masteryLevel: masteryLevel,
    fill: iconColor,
    width: "1.5rem",
    height: "1.5rem",
    ariaLabel: label,
    ariaHidden: scoreDisplayFormat === ScoreDisplayFormat.ICON_AND_LABEL
  }), /*#__PURE__*/React.createElement(Label, {
    scoreDisplayFormat: scoreDisplayFormat,
    score: score,
    totalScore: totalScore,
    text: label
  }));
};